'use-client';
// material ui
import { LicenseInfo } from '@mui/x-license';

const licenseKey =
  '3ed818970e0774a40b8d9a5bea631887Tz0xMjUwOTIsRT0xODAxNDM5OTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y';

LicenseInfo.setLicenseKey(licenseKey);

export default function MuiXLicense() {
  return null;
}
